import { Result } from './model';
export function castOr(value, sanitizer, defaultValue) {
    var result = sanitizer(value, '');
    if (Result.isOk(result)) {
        return result.ok;
    }
    else {
        return defaultValue;
    }
}
